import React, { useRef } from "react";
import type { MessageSource } from "../models.ts";
import ContextMenu, { ContextMenuItem } from "./ContextMenu/index.ts";
import { helperService } from "@services/helperService";
import { ImgSources } from "./Images/ImgSources";
import { ImgExternalLink } from "./Images/ImgExternalLink";

interface MessageSourcesProps {
  sources?: MessageSource[];
}

export function MessageSources({ sources }: MessageSourcesProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  if (!sources || sources.length === 0) return null;

  const maxVisible = 5;
  const visibleSources = sources.slice(0, maxVisible);
  const extraCount = sources.length - maxVisible;

  return (
    <div className="message-sources">
      <button ref={buttonRef} className="sources-btn" title="View sources">
        <ImgSources size={14} />
        <span className="sources-label">Sources</span>
        <span className="sources-favicons">
          {visibleSources.map((s, i) => (
            <span key={i} className="source-favicon-wrap">
              {s.favicon ? (
                <img
                  src={helperService.faviconProxyUrl(s.favicon)}
                  alt=""
                  className="source-favicon"
                  onError={(e) => {
                    const img = e.target as HTMLImageElement;
                    img.style.display = 'none';
                    (img.nextElementSibling as HTMLElement | null)?.classList.remove('source-favicon-fallback--hidden');
                  }}
                />
              ) : null}
              <span className={`source-favicon-fallback${s.favicon ? ' source-favicon-fallback--hidden' : ''}`}>
                {(s.title || s.link).charAt(0).toUpperCase()}
              </span>
            </span>
          ))}
          {extraCount > 0 && <span className="sources-extra">+{extraCount}</span>}
        </span>
      </button>
      <ContextMenu container={buttonRef as React.RefObject<HTMLElement | null>} showOnClick>
        {() => (
          <>
            {sources.map((s, i) => (
              <ContextMenuItem
                key={i}
                onClick={() => window.open(s.link, '_blank', 'noopener,noreferrer')}
                onAuxClick={(e) => { if (e.button === 1) { e.preventDefault(); window.open(s.link, '_blank', 'noopener,noreferrer'); } }}
                title={
                  <span className="source-menu-item">
                    <span className="source-menu-favicon-wrap">
                      {s.favicon ? (
                        <img
                          src={helperService.faviconProxyUrl(s.favicon)}
                          alt=""
                          className="source-menu-favicon"
                          onError={(e) => {
                            const img = e.target as HTMLImageElement;
                            img.style.display = 'none';
                            (img.nextElementSibling as HTMLElement | null)?.classList.remove('source-favicon-fallback--hidden');
                          }}
                        />
                      ) : null}
                      <span className={`source-favicon-fallback source-menu-favicon-fallback${s.favicon ? ' source-favicon-fallback--hidden' : ''}`}>
                        {(s.title || s.link).charAt(0).toUpperCase()}
                      </span>
                    </span>
                    <span className="source-menu-text">
                      <span className="source-menu-title">{s.title || s.link}</span>
                      <span className="source-menu-url">{s.link}</span>
                    </span>
                    <ImgExternalLink size={12} />
                  </span>
                }
              />
            ))}
          </>
        )}
      </ContextMenu>
    </div>
  );
}
